export default "__VITE_ASSET__5174d049__"